module.exports = __webpack_public_path__ + "img/demo1-about-en.ab5b44c4.png";